import React, { useEffect, useState } from 'react';
import { Animated, Easing, Image, View } from 'react-native';
import { themes } from 'src/theme/theme';
import ideaIcon from 'src/assets/idea-3x.png';
import checkIcon from 'src/assets/check-circle-3x.png';
import closeError from 'src/assets/closeError.png';
import warningIcon from 'src/assets/warning-3x.png';
import Typography from 'src/components/Text/Text';
import { styles } from './Toast.styles';
// Define the props interface
interface ToastProps {
  text?: string;
  type?: 'success' | 'error' | 'warning' | 'idea';
  animate?: boolean;
  testID?: string;
}
const Toast: React.FC<ToastProps> = ({ text, type = 'success', animate = true, testID }) => {
  const [fadeAnim] = useState(new Animated.Value(0)); // Initial opacity is 0
  const [visible, setVisible] = useState(true);
  const iconStyle = {
    width: 24,
    height: 24,
  };

  useEffect(() => {
    if (animate) {
      // Fade in
      Animated.timing(fadeAnim, {
        toValue: 1, // Full opacity
        duration: 500,
        easing: Easing.out(Easing.ease),
        useNativeDriver: true,
      }).start(() => {
        // Stay for 2 seconds, then fade out
        // eslint-disable-next-line no-undef
        setTimeout(() => {
          Animated.timing(fadeAnim, {
            toValue: 0, // Fade out
            duration: 500,
            easing: Easing.in(Easing.ease),
            useNativeDriver: true,
          }).start(() => setVisible(false));
        }, 4000);
      });
    }
  }, [animate, fadeAnim]);

  const getBackgroundColor = (type: ToastProps['type']) => {
    const { toast, gray_blue, red, yellow } = themes.light;
    switch (type) {
      case 'success':
        return toast[1];
      case 'idea':
        return gray_blue[7];
      case 'error':
        return red[6];
      case 'warning':
        return yellow[4];
      default:
        return toast[1]; // Fallback to success color
    }
  };
  const getIcon = (type: ToastProps['type']) => {
    switch (type) {
      case 'success':
        return checkIcon;
      case 'idea':
        return ideaIcon;
      case 'error':
        return closeError;
      case 'warning':
        return warningIcon;
      default:
        return checkIcon; // Fallback to success icon
    }
  };
  if (!visible) return null;
  const opacity = animate ? fadeAnim : 1;
  return (
    <Animated.View
      testID={testID}
      style={[
        styles.toast,
        {
          opacity: opacity,
          backgroundColor: getBackgroundColor(type),
        },
      ]}>
      <View style={styles.iconContainer}>
        <Image source={getIcon(type)} style={type === 'warning' ? styles.icon : iconStyle} />
      </View>
      <Typography variant="body2" style={styles.text}>
        {text}
      </Typography>
    </Animated.View>
  );
};

export default Toast;
